"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRippleStyles = void 0;
var _styledComponents = require("styled-components");
var _grey = _interopRequireDefault(require("../tokens/color/grey"));
// Source: https://ghinda.net/article/css-ripple-material-design/

var DEFAULTS = {
  COLOR: _grey["default"].z300,
  SIZE: "50rem"
};
var ripple = /*#__PURE__*/(0, _styledComponents.keyframes)(["0%{transform:translate(-50%,-50%) scale(0);}60%{transform:translate(-50%,-50%) scale(1);}100%{opacity:0;transform:translate(-50%,-50%) scale(1);}"]);
var getRippleStyles = exports.getRippleStyles = function getRippleStyles() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULTS.COLOR;
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULTS.SIZE;
  return (0, _styledComponents.css)(["@media (max-width:480px){position:relative;overflow:hidden;&:after{content:\"\";display:block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(0);width:", ";height:", ";background-color:", ";border-radius:100%;opacity:0.6;}&:not(:active):after{animation:", " 1s ease-out;}&:after{visibility:hidden;}&:focus:after{visibility:visible;}}"], size, size, color, ripple);
};